import http from "../utils/http";
// 人员添加-人员编辑
export function personAdd(type,params) {
    let url_=type=='add'?'/employee/manage/add':'/employee/manage/update'
    return http({
        method: "post",
        url: url_,
        data:params
    });
}

// 人员详情
export function personInfo(id) {
    return http({
        method: "get",
        url: "/employee/manage/find?employeeId="+id,
    });
}


// 学校概况
export function xcwsEntityExt() {
    return http({
        method: "get",
        url: "/system/xcwsEntityExt/findV2",
        // url: "/system/xcwsEntityExt/find",
    });
}
// 学校概况
export function xcwsEntityExtUpdate(params) {
    return http({
        method: "POST",
        url: "/system/xcwsEntityExt/updateV2",
        // url: "/system/xcwsEntityExt/update",
        data:params
    });
}